import React from "react";
import {useNavigate} from "react-router-dom";
import ChartLoadingOverlay from "../../components/Utils/ChartLoadingOverlay";
import {addHeaderTab, openHeaderTabWithChild} from "../../components/pageTabs/pageTabsStorage";

const BULLETIN_LIST_PATH = "/settings/bulletinboardlist/main";
const BULLETIN_LIST_TITLE = "자료실";

const formatBulletinDate = (createdAt) => {
    if (!createdAt) return "";
    if (typeof createdAt === "string") {
        return createdAt.length >= 10 ? createdAt.substring(0, 10) : createdAt;
    }
    return "";
};

function BulletinRow({item, onClick}) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="flex w-full items-center justify-between gap-3 border-b border-[#eeeeee] py-3 text-left last:border-b-0 hover:bg-[#fafafa]"
        >
            <span className="min-w-0 flex-1 truncate text-[14px] text-[#111827]">
                {item?.subject ?? ""}
            </span>
            <span className="shrink-0 text-[13px] text-[#9ca3af]">
                {formatBulletinDate(item?.createdAt)}
            </span>
        </button>
    );
}

function TotalBulletinContent({items}) {
    const navigate = useNavigate();

    const handleRowClick = (item) => {
        if (item?.link && item?.id != null) {
            const detailUrl = `${item.link}/${item.id}`;
            openHeaderTabWithChild({
                header: {
                    title: BULLETIN_LIST_TITLE,
                    url: BULLETIN_LIST_PATH,
                    icon: "setting",
                },
                child: {
                    title: item.subject || BULLETIN_LIST_TITLE,
                    url: detailUrl,
                },
            });
            navigate(detailUrl);
        }
    };

    return (
        <div className="total-bulletin flex h-full min-h-0 flex-col bg-white">
            <div className="mb-2 flex shrink-0 items-center justify-between gap-2">
                <h3 className="text-[21px] font-bold leading-none text-[#111827]">자료실</h3>
                <button
                    type="button"
                    onClick={() => {
                        addHeaderTab({
                            title: BULLETIN_LIST_TITLE,
                            url: BULLETIN_LIST_PATH,
                            icon: "setting",
                        });
                        navigate(BULLETIN_LIST_PATH);
                    }}
                    className="shrink-0 text-[13px] text-[#9ca3af] transition-colors hover:text-[#6b7280]"
                >
                    더보기 &gt;
                </button>
            </div>

            {items.length > 0 ? (
                <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
                    {items.map((item, index) => (
                        <BulletinRow
                            key={item.id ?? index}
                            item={item}
                            onClick={() => handleRowClick(item)}
                        />
                    ))}
                </div>
            ) : (
                <div className="flex flex-1 items-center justify-center text-[13px] text-[#9ca3af]">
                    No Data.
                </div>
            )}
        </div>
    );
}

export function TotalBulletin({data, loading = false}) {
    const items = Array.isArray(data) ? data : [];

    if (!items.length && loading) {
        return (
            <div className="total-bulletin relative flex h-full min-h-0 flex-col bg-white">
                <h3 className="shrink-0 text-[16px] font-bold leading-none text-[#111827]">자료실</h3>
                <ChartLoadingOverlay />
            </div>
        );
    }

    return (
        <div className="relative flex h-full min-h-0 flex-col">
            {loading && <ChartLoadingOverlay />}
            <TotalBulletinContent items={items} />
        </div>
    );
}

export default TotalBulletin;
